//#region src/locales/en/stage.yaml
var data = {
	"character-switcher": {
		"title": "Switch character",
		"manage": "Manage characters",
		"empty": "No characters yet",
		"failed": "Could not switch characters. Try again."
	},
	"mobile-tools": {
		"sign-in": "Sign in to AIRI",
		"account-description": "Account and preferences",
		"sound": "Sound",
		"character-voice": "Character voice",
		"title": "Settings",
		"appearance": "Appearance",
		"dark-mode": "Dark mode",
		"application": "Application",
		"more": "More",
		"background": "Background",
		"settings": "All settings",
		"about": "About",
		"view": "View",
		"close-view": "Save and close view controls",
		"hearing": "Hearing"
	},
	"chat": {
		"provider-configuration": {
			"title": "Chat provider isn't configured",
			"description": "Choose and validate a provider in Settings before sending a message.",
			"action": "Open provider settings"
		},
		"voice-message": {
			"title": "Voice message",
			"record": "Record a message",
			"finish": "Finish recording",
			"dictate": "Hold to dictate",
			"recording": "Recording",
			"starting": "Starting microphone",
			"preparing": "Preparing audio preview",
			"preview": "Recorded voice message"
		},
		"voice-preview": {
			"processing": "Finishing transcription",
			"device": "Audio input device",
			"device-description": "Select the microphone for this recording.",
			"device-placeholder": "Select a microphone",
			"level": "Input level",
			"activity": "Speech activity",
			"silence": "Silence",
			"speech": "Speech",
			"threshold": "Detection threshold",
			"sensitivity": "Sensitivity",
			"sensitivity-description": "Adjust the speech indicator threshold.",
			"start": "Start recording",
			"stop": "Finish recording",
			"failed": "The audio operation failed."
		},
		"voice-draft": {
			"title": "Voice draft",
			"select": "Show draft {number}",
			"discard": "Discard draft",
			"finalizing": "Finishing…"
		},
		"voice-input": "Voice input",
		"error-details": {
			"show": "Show details",
			"hide": "Hide details"
		},
		"images": {
			"empty": "Share a thought or a picture.",
			"use-vision": "Use the vision model for chat images",
			"use-vision-description": "Choose a provider and model below. It reads attached images before your chat model replies. Without a vision model, images go directly to the chat model.",
			"attach": "Attach images",
			"remove": "Remove {name}",
			"unsupported": "Use PNG, JPEG, WebP, or GIF images.",
			"too-large": "Each image must be 3 MB or smaller.",
			"too-many": "Attach up to {count} images at a time.",
			"total-too-large": "All attached images together must be 3 MB or smaller.",
			"read-failed": "Could not read this image. Try again.",
			"no-description": "The vision model returned no image description. Check Settings → Modules → Vision and try again.",
			"reading": "Reading images…",
			"description": "Image attachment"
		},
		"actions": {
			"reply": "Reply",
			"retry": "Retry",
			"send": "Send message",
			"stop": "Stop response"
		},
		"message": { "character-name": {
			"airi": "AIRI",
			"core-system": "Core System",
			"you": "You"
		} },
		"reply": {
			"cancel": "Cancel reply",
			"message": "Message",
			"replying-to": "Replying to {name}"
		},
		"reasoning": "Reasoning",
		"swipe-demo": {
			"show-label": "Show labels",
			"delete": "Delete",
			"archive": "Archive",
			"pin": "Pin",
			"actions": "Show actions",
			"row": "Conversation {n}"
		},
		"sessions": {
			"delete-short": "Delete",
			"confirm-delete-short": "Confirm delete",
			"title": "Conversations",
			"new": "New conversation",
			"current": "Current",
			"confirm-delete": "Delete this conversation and its messages?",
			"cancel": "Cancel",
			"empty": "No conversations yet",
			"cloud-badge": "Synced to cloud",
			"new-chat-fallback": "New chat",
			"delete": "Delete conversation"
		}
	},
	"render-error": {
		"title": "{renderer} could not render this model",
		"description": "The model is selected, but the Stage could not display it.",
		"report-description": "{renderer} failed to render the selected model.\nModel ID: {modelId}\nError: {error}"
	},
	"startup": {
		"failed": "Startup failed",
		"failed-resource": "Could not load {resource}",
		"recover": "Try again. If it fails again, open the details below.",
		"recover-model": "Try again, or continue without a character. You can select another model later.",
		"details": "What happened?",
		"close-details": "Close details",
		"retry": "Retry",
		"continue-without-model": "Continue Anyway",
		"model-timeout": "The character model took too long to load. Check your connection and retry.",
		"resources": {
			"auth": "account settings",
			"modelIndex": "model list",
			"card": "character settings",
			"chat": "chat history",
			"services": "app services",
			"modelData": "saved models",
			"modelSelection": "model settings",
			"audio": "audio settings",
			"route": "page",
			"model": "character model"
		}
	},
	"message": "Say something...",
	"send-mode": {
		"title": "Send key",
		"enter": "Enter",
		"ctrl-enter": "Ctrl + Enter",
		"double-enter": "Double Enter"
	},
	"speech-output": {
		"mute": "Mute voice",
		"unmute": "Unmute voice"
	},
	"operations": {
		"load-models": "Load Models",
		"load-models-status": {
			"loading": "Loading",
			"ready": "Ready"
		}
	},
	"select-a-audio-input": "Select a Audio Input",
	"select-a-model": "Select a model",
	"select-a-voice": "Choose a voice",
	"viewers": { "debug-menu": {
		"emotions": "Emotions",
		"emotions-btn": {
			"angry": "😠 Angry",
			"awkward": "😳 Awkward",
			"happy": "😄 Happy",
			"neutral": "🙂 Neutral",
			"question": "🤔 Question",
			"sad": "😫 Sad",
			"surprised": "🤯 Surprised",
			"think": "🤨 Think"
		},
		"vrm": {
			"camera": "Camera",
			"model": { "title": "Model" }
		}
	} },
	"profile-switcher": {
		"no-profile": "No Profile",
		"no-profiles": "No profiles yet",
		"save-as-new": "Save as New Profile",
		"new-profile-name": "Profile name",
		"manage": "Manage Profiles"
	},
	"promo-banner": { "items": {
		"signin": {
			"watermark": "Moon",
			"fallbackLabel": "Moon Gift",
			"title": "7-Day Sign-In",
			"eventName": "Sign in to claim stardust, avatar frames, and launch gifts.",
			"date": "03/28 - 04/10",
			"reward": "Up to 120 Stardust",
			"cta": "Sign In"
		},
		"build": {
			"watermark": "Build",
			"fallbackLabel": "Build Bonus",
			"title": "Supply Box Bonus",
			"eventName": "Finish construction tasks to earn bonus vouchers and double materials.",
			"date": "03/30 - 04/12",
			"reward": "5 Supply Vouchers + Upgrade Materials",
			"cta": "View Tasks"
		},
		"spring": {
			"watermark": "Spring",
			"fallbackLabel": "Spring Draw",
			"title": "Capsule Carnival",
			"eventName": "Join the spring draw to unlock bubbles, charms, and themed furniture.",
			"date": "04/01 - 04/18",
			"reward": "Half-Price First Pull + Rare Charm",
			"cta": "Draw Now"
		},
		"coupon": {
			"watermark": "Talk",
			"fallbackLabel": "Coupon",
			"title": "Top-Up Coupon",
			"eventName": "Finish chat interactions to claim coupons for expansion and voice packs.",
			"date": "04/02 - 04/20",
			"reward": "Save 6 on 30 / Save 15 on 68",
			"cta": "Claim Coupon"
		},
		"home": {
			"watermark": "Home",
			"fallbackLabel": "Room Theme",
			"title": "Spring Theme Update",
			"eventName": "Unlock window, desk, and night-lamp themes to refresh your room.",
			"date": "04/05 - 04/22",
			"reward": "Free Theme Draw Ticket on Sign-in",
			"cta": "View Theme"
		}
	} },
	"waiting": "Waiting",
	"websocket-status": {
		"connected": "Connected",
		"disconnected": "No connection",
		"open-settings": "Open connection settings"
	},
	"computer-use": {
		"label": "Use computer",
		"description": "Allow this chat window to inspect and control native apps on this computer."
	},
	"status": {
		"preparing": "Preparing microphone",
		"listening": "Listening",
		"paused": "Listening paused while AIRI speaks",
		"transcribing": "Transcribing",
		"hearing-error": "Could not transcribe audio",
		"no-transcript": "Recognized speech will appear here.",
		"signing-in": "Finish signing in in your browser",
		"confirming": "Confirming sign-in",
		"signed-in": "Signed in",
		"sign-in-error": "Sign-in failed",
		"sign-in-unconfirmed": "Could not confirm your session. Please sign in again.",
		"dismiss": "Dismiss",
		"configure-hearing": "Select and configure a Hearing provider in Settings."
	}
};
//#endregion
export { data as default };
